"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Phone } from "lucide-react";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        {[1, 2, 3, 4, 5].map(i => <div key={i} data-index={i} className="h-6 w-20 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-x-8">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="relative py-2 text-sm font-default uppercase tracking-wider text-foreground transition-colors hover:text-primary after:absolute after:bottom-0 after:left-1/2 after:h-[2px] after:w-0 after:-translate-x-1/2 after:bg-primary after:transition-all after:duration-300 hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (hashPart === '') {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            return;
          }
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <section data-section-id="252949" id="cabecera-recambios-maquinaria" className={`sticky top-0 z-50 w-full transition-all duration-500 bg-background text-foreground ${isScrolled ? "bg-background/80 backdrop-blur-[12px] border-b border-border py-3 shadow-lg" : "py-7"}`}>
      <div className="container mx-auto px-8 max-w-[1664px] flex items-center justify-between">
        
        <Link to="/" className="flex-shrink-0">
          <WvcLogo className="w-auto !h-10 ![max-height:2.5rem] [&_svg]:w-auto [&_svg]:!h-full" />
        </Link>

        <Link to="tel:607956075" className="hidden lg:flex items-center gap-2 text-primary font-medium ml-16 hover:opacity-80 transition-opacity">
          <Phone className="size-4" />
          <span>607956075</span>
        </Link>

        <div className="flex-1 flex justify-center">
          <MenuProvider menu_id="45">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>

        <div className="flex-shrink-0 hidden md:flex items-center gap-4">
          <Link to="#oportunidades-en-recambios">
            <Button variant="ghost" className="rounded-md border-0 bg-secondary text-secondary-foreground hover:bg-secondary/80 hover:scale-105 transition-all duration-300 px-6 py-3 h-auto font-default uppercase tracking-tight text-sm shadow-md">RECAMBIOS EN OFERTA</Button>
          </Link>
          <Link to="/ContactPage">
            <Button variant="ghost" className="rounded-md border-0 bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-105 transition-all duration-300 px-8 py-3 h-auto font-default uppercase tracking-tight text-sm shadow-md">Contactar&nbsp;</Button>
          </Link>
        </div>
      </div>
    </section>;
}